import { useCallback, useEffect, useState } from 'react';
import { api, type ProviderCard } from '../../api';
import { Avatar, EmptyState, TopBar, useToast } from '../../components/ui';
import { ProviderTile } from '../../components/ProviderPost';
import { ProviderProfile } from '../ProviderProfile';
import { Loading } from './Discover';
import { useNav } from '../../nav';
import { useT } from '../../i18n';

export function FavoritesPage() {
  const t = useT();
  const nav = useNav();
  const [items, setItems] = useState<ProviderCard[] | null>(null);
  const load = useCallback(() => {
    api.favorites().then(setItems).catch(() => setItems([]));
  }, []);
  useEffect(load, [load]);
  return (
    <div className="flex h-full flex-col">
      <TopBar title={t('profile.favorites')} />
      <div className="flex-1 overflow-y-auto pb-10 pt-3">
        {!items && <Loading />}
        {items && !items.length && <EmptyState icon="🤍" text={t('favorites.empty')} />}
        <div className="grid grid-cols-2 gap-2 px-3">
          {items?.map((p) => (
            <ProviderTile key={p.id} p={p} onOpen={() => nav.push(`provider:${p.id}`, <ProviderProfile id={p.id} initial={p} canBook onChanged={load} />)} />
          ))}
        </div>
      </div>
    </div>
  );
}

export function BlockedPage() {
  const t = useT();
  const toast = useToast();
  const [items, setItems] = useState<Array<{ id: string; displayName: string }> | null>(null);
  const load = useCallback(() => {
    api.blocks().then(setItems).catch(() => setItems([]));
  }, []);
  useEffect(load, [load]);
  return (
    <div className="flex h-full flex-col">
      <TopBar title={t('profile.blocked')} />
      <div className="flex-1 overflow-y-auto pb-10">
        {!items && <Loading />}
        {items && !items.length && <EmptyState icon="🛡️" text={t('blocked.empty')} />}
        {items?.map((b) => (
          <div key={b.id} className="flex items-center gap-3 border-b border-black/5 px-4 py-3">
            <Avatar name={b.displayName} size={44} />
            <span className="flex-1 font-medium">{b.displayName}</span>
            <button
              className="rounded-full bg-tg-secondary px-4 py-1.5 text-sm font-semibold"
              onClick={async () => {
                await api.unblock(b.id);
                toast(t('block.unblocked'));
                load();
              }}
            >
              {t('provider.unblock')}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
